import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * User service class containing all methods to retrieve users
 */
class UserService {
  static getUsers(limit = 10, page = 1, filter = '') {
    return ApiHelper.fetch(`${API.URL + API.USERS}/${limit}/${page}?filter=${filter}`)
  }

  static getUser(email) {
    return ApiHelper.fetch(`${API.URL + API.USER}/${email}`)
  }

  static addUser(user) {
    return ApiHelper.fetch(`${API.URL + API.USERS}`, {
      method: 'POST',
      body: JSON.stringify({
        user
      })
    })
  }

  static updateUser(user) {
    return ApiHelper.fetch(`${API.URL + API.USER}`, {
      method: 'PUT',
      body: JSON.stringify({
        user
      })
    })
  }
}

export default UserService
